import styled from "styled-components";
import { MdEmail } from "react-icons/md";
import { FaMapMarkerAlt, FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaLinkedinIn } from "react-icons/fa";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import { Container } from "../../theme/styles";
import { Form } from "./components/Form";
import medias_url from "../../mocks/social_media";
import { usePageTrack } from "../../hooks/useAnalyticsPageTracker";


function Contact() {
  usePageTrack();

  return (
    <>
      <Header />
      <Container>
        <Title>Contato</Title>
      </Container>
      <Content>
        <Info>
          <InfoTitle>Dúvidas relacionadas ao <br /> tratamento de dados pessoais:</InfoTitle>
          <List>
            <Item marginBottom={16}>
              <Square size={48}><MdEmail color="#fff" size={28} /></Square>
              <Text fontSize={26}>{`${medias_url.contactEmail}`}</Text>
            </Item>
            <Item marginBottom={16}>
              <Square size={48}><FaMapMarkerAlt color="#fff" size={28} /></Square>
              <Text fontSize={20}>Rua Evaristo da Veiga, n. 16, Sala 1407 <br /> Rio de Janeiro, RJ, 20031040, BR</Text>
            </Item>
          </List>
          <Divider />
          <InfoTitle>Siga nossas redes:</InfoTitle>
          <List>
            <Item marginBottom={4}>
              <LinkUI href={medias_url.facebook} target="_blank">
                <Square size={32}><FaFacebookF color="#fff" size={22} /></Square>
                <Text fontSize={18}>{medias_url.facebook.split('www.')[1]}</Text>
              </LinkUI>
            </Item>
            <Item marginBottom={4}>
              <LinkUI href={medias_url.instagram} target="_blank">
                <Square size={32}><FaInstagram color="#fff" size={22} /></Square>
                <Text fontSize={18}>{medias_url.instagram.split('www.')[1]}</Text>
              </LinkUI>
            </Item>
            <Item marginBottom={4}>
              <LinkUI href={medias_url.twitter} target="_blank">
                <Square size={32}><FaTwitter color="#fff" size={22} /></Square>
                <Text fontSize={18}>{medias_url.twitter.split('www.')[1]}</Text>
              </LinkUI>
            </Item>
            <Item marginBottom={4}>
              <LinkUI href={medias_url.youtube} target="_blank">
                <Square size={32}><FaYoutube color="#fff" size={22} /></Square>
                <Text fontSize={18}>youtube.com/onda</Text>
              </LinkUI>
            </Item>
            <Item marginBottom={4}>
              <LinkUI href={medias_url.linkedin} target="_blank">
                <Square size={32}><FaLinkedinIn color="#fff" size={22} /></Square>
                <Text fontSize={18}>{medias_url.linkedin.split('www.')[1]}</Text>
              </LinkUI>
            </Item>
          </List>
        </Info>
        <Form />
      </Content>
      <Footer />
    </>
  );
}

export default Contact;

const Content = styled(Container)`
  padding: 32px 0 64px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    flex-direction: column;
    padding: 0;
  }
`;

const Title = styled.h2`
  padding: 80px 0 0;
  font-size: 60px;
  color: ${({ theme }) => theme.colors.blue.dark};

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    padding: 40px 0 24px;
    text-align: center;
    margin: auto;
    font-size: 52px;
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(54% - 12px);
  padding: 32px 0 0;
  position: relative;
  border: ${({ theme }) => `1px solid ${theme.colors.blue.dark}`};
  border-radius: 16px;
  padding: 32px 32px 64px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: 100%;
    border: none;
    padding: 0 32px;
  }
`;

const InfoTitle = styled.span`
  color: ${({ theme }) => theme.colors.black.dark};
  font-size: 26px;
  margin-bottom: 16px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 20px;
    line-height: 1;
  }
`;

const List = styled.ul`
  list-style-type: none;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    &:last-of-type {
      margin-bottom: 32px;
    }
  }
`;

const Item = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: ${({ marginBottom }: { marginBottom: number }) => `${marginBottom}px`};

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const LinkUI = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const Square = styled.span`
  background-color: ${({ theme }) => theme.colors.blue.dark};
  border-radius: 3px;
  width: ${({ size }: { size: number }) => `${size}px`};
  height: ${({ size }: { size: number }) => `${size}px`};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
`;

const Text = styled.span`
  color: ${({ theme }) => theme.colors.blue.dark};
  font-size: ${({ fontSize }: { fontSize: number }) => `${fontSize}px`};

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: ${({ fontSize }: { fontSize: number }) => fontSize <= 20 ? '16px': '22px'};
  }
`;

const Divider = styled.hr`
  border: none;
  background-color: ${({ theme }) => theme.colors.gray.darker};
  height: 2px;
  width: 100%;
  margin: 24px auto;
`;